module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei4.svg";